module.exports = __webpack_public_path__ + "static/img/伙伴客户-空中总医院.0d4e14dd.png";